import { Component } from '@angular/core';

@Component({
  selector: 'app-modals-search',
  imports: [],
  templateUrl: './modals-search.component.html',
  styleUrl: './modals-search.component.scss'
})
export class ModalsSearchComponent {

}
